var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 48C10.7472 48 0 37.2528 0 24C0 10.7472 10.7472 0 24 0C37.2528 0 48 10.7472 48 24C48 37.2528 37.2528 48 24 48Z",
    fill: "#D5D5D5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34.4853 13.4862H13.5143V34.5137H34.4853V13.4862Z",
    fill: "#F1F5F7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.0001 26.2111L34.4853 34.5137V18.1227L24.0001 26.2111Z",
    fill: "#DCE6EA"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M35.359 13.4862H34.4853L24.0001 21.7886L13.5143 13.4862H12.6407C11.1938 13.4862 10.0193 14.6636 10.0193 16.1146V31.8852C10.0193 33.336 11.1938 34.5137 12.6407 34.5137H13.5143V18.1227L24.0001 26.2094L34.4853 18.1207V34.5137H35.359C36.8062 34.5137 37.9806 33.3359 37.9806 31.8852V16.1147C37.9807 14.6636 36.8063 13.4862 35.359 13.4862Z",
    fill: "#F84437"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.982b7b19cb3e2edabba34fdabd19b087.svg";
export { ForwardRef as ReactComponent };